import {internalProps} from '../types/BS_types'

import {safeLocalStorage} from './safeStorages'

// Internal
export const isNightly = () => internalProps['teamcity.internal.nightly']
export const buildChangesPopupLimit = internalProps['teamcity.internal.buildChangesPopupLimit']
export const isFullDistributionsEnabled =
  internalProps['teamcity.internal.agent.distribution.jdk.bundle.enabled']

// General
export const isDarkThemeAdapterEnabled =
  internalProps['teamcity.ui.darkTheme.adapter.enabled'] === true
export const isGlobalDarkModeAllowed = internalProps['teamcity.ui.darkTheme.allowed'] === true
export const isCloud = internalProps['teamcity.cloud.enabled']
export const isSakuraEnabled = internalProps['teamcity.ui.experimental']
export const customWelcomeTitle = internalProps['teamcity.ui.customWelcomeTitle']
export const showObligatoryHints = internalProps['teamcity.ui.showObligatoryHints'] === true
export const isSakuraRelaseBunnerEnabled =
  internalProps['teamcity.ui.sakura.releaseBanner.enabled'] === true
export const isBypassSubscriptionEnabled =
  internalProps['teamcity.ui.sidebar.skipWSEventsSubscription']
export const isServiceWorkerEnabled = internalProps['teamcity.ui.useServiceWorkers']
export const subscriptionDebounceInterval =
  internalProps['teamcity.ui.subscriptions.debounceInterval']
export const shouldSaveSidebarSearchState = internalProps['teamcity.ui.sidebar.saveSearchState']
export const statusesThrottleInterval = internalProps['teamcity.ui.statuses.throttleInterval']
export const showLicenseAgreementToAllUsers =
  internalProps['teamcity.ui.showLicenseAgreementToAllUsers'] !== false
export const requestPoolSize = internalProps['teamcity.ui.requestPoolSize']
export const isHiddenArtifactsExtendedNamesEnabled =
  internalProps['teamcity.hidden.artifacts.use.extended.names']
export const showDownloadAllArtifactsLink =
  internalProps['teamcity.ui.showDownloadAllArtifactsLink'] !== false
export const overviewBuildTypesLimit = internalProps['teamcity.overviewPage.buildTypes.limit']
export const isNewAgentCompatibleConfigurationsTabEnabled =
  internalProps['teamcity.ui.newAgentCompatibleConfigurationsTab']
export const agentPoolsFavoriteLimit = internalProps['teamcity.ui.agentPoolsFavoriteLimit']
export const agentPreviewsUpdateTimeout = internalProps['teamcity.ui.agentPreviewsUpdateTimeout']
export const agentDataUpdateTimeout = internalProps['teamcity.ui.agentDataUpdateTimeout']
export const showAuthAgentDialog = internalProps['teamcity.ui.showAuthAgentDialog'] === true
export const hiddenCloudProfileTypes = internalProps['teamcity.cloudProfiles.hiddenCloudTypes']
export const isCompositeBuildsOnTimelineEnabled =
  internalProps['teamcity.ui.compositeBuildsOnTimeline.enabled']
export const isInvestigationsTabEnabled = internalProps['teamcity.ui.sakuraInvestigationsTab']
export const isProblemsTabEnabled = internalProps['teamcity.ui.sakuraProblemsTab']
export const isInvestigationsPageEnabled = internalProps['teamcity.ui.newInvestigationsPage']
export const isBuildStepSelectorEnabled = internalProps['teamcity.ui.buildStepSelector.enabled']
export const isCreateProjectNewUiEnabled = internalProps['teamcity.ui.createProject.newui.enabled']
export const isCreateBuildTypeNewUiEnabled =
  internalProps['teamcity.ui.createBuildType.newui.enabled']
export const isCreateConnectionNewUiEnabled =
  internalProps['teamcity.ui.createConnection.newui.enabled']
export const isFeedbackCSATEnabled = internalProps['teamcity.feedback.csat.enabled']
export const isFeedbackCSATTestingEnabled = internalProps['teamcity.feedback.csat.testing.enabled']
export const isTechInsightsPanelEnabled =
  internalProps['teamcity.feedback.csat.techInsightsPanel.enabled']
export const isChainPanningEnabled = internalProps['teamcity.ui.chainPanning.enabled']
export const isFromAnyGitURLEnabled = internalProps['teamcity.ui.fromAnyGitURL.enabled']

// Pipelines
export const isProjectsAndBuildTypesEnabled = () =>
  internalProps['teamcity.pipelines.projects.enabled'] !== false // !!!! Enabled by default
const isPipelinesEnabled = internalProps['teamcity.pipelines.enabled'] // !!!! Enabled by default, please use isPipelinesCreationEnabled !!!!
export const isPipelinesCreationEnabled = internalProps['teamcity.pipelines.creation.enabled']
export const isPipelinesEnabledInExclusiveMode = () =>
  isPipelinesEnabled && !isProjectsAndBuildTypesEnabled()
export const isTestNpmConnectionEnabled =
  internalProps['teamcity.pipelines.testNpmConnection.enabled']
export const isUnityRunnerEnabled = internalProps['teamcity.pipelines.unity.enabled']
export const isPipelinesAgentPageEnabled = () =>
  isPipelinesEnabled &&
  internalProps['teamcity.pipelines.agentPage.enabled'] === true &&
  safeLocalStorage.getItem('isPipelinesAgentPageEnabled') !== 'false'
export const jobCountSoftLimit = internalProps['teamcity.pipelines.jobCountSoftLimit']
export const jobCountHardLimit = internalProps['teamcity.pipelines.jobCountHardLimit']
export const dependencyCacheEnabled = internalProps['teamcity.pipelines.dependencyCache.enabled']
export const isMuteInvestigateButtonEnabled =
  internalProps['teamcity.pipelines.muteInvestigateButton.enabled']
export const isPipelinesInterviewRecruitmentBannerEnabled =
  isPipelinesEnabledInExclusiveMode() &&
  internalProps['teamcity.pipelines.interviewRecruitmentBanner.enabled']
export const interviewRecruitmentBannerLink =
  internalProps['teamcity.pipelines.interviewRecruitmentBanner.link']
export const interviewRecruitmentBannerButtonName =
  internalProps['teamcity.pipelines.interviewRecruitmentBanner.buttonName']
export const interviewRecruitmentBannerMainMessage =
  internalProps['teamcity.pipelines.interviewRecruitmentBanner.mainMessage']
export const interviewRecruitmentBannerAdditionalMessage =
  internalProps['teamcity.pipelines.interviewRecruitmentBanner.additionalMessage']
export const isNotificationsFeatureEnabled =
  internalProps['teamcity.pipelines.feature.notifications.enabled']
export const isPipelineNotificationsEnabled =
  internalProps['teamcity.pipelines.feature.pipeline.notifications.enabled']
// Temporary hide feature toggle
// Task: TCP-1363 Remove support for statuses of recent job runs in edit mode
export const isTemporaryHideFailedJobStateEditMode = true
export const isPipelineCompatibilityAgentsEnabled =
  internalProps['teamcity.pipelines.feature.compatibilityAgents.enabled']
export const customAgentsNames = internalProps['teamcity.pipelines.customAgentsNames']
export const isPipelinesFeedbackFormEnabled =
  internalProps['teamcity.pipelines.feedbackForm.enabled']
export const isStatusPublishingFeatureEnabled =
  internalProps['teamcity.pipelines.statusPublishing.configuration.enabled']
export const isWithoutVcsFeatureEnabled =
  internalProps['teamcity.pipelines.feature.withoutVcs.enabled']
export const isWelcomePopupEnabled = () =>
  internalProps['teamcity.pipelines.welcomePopup.enabled'] === true
export const isEarlyAccessLabelEnabled =
  internalProps['teamcity.pipelines.earlyAccessLabel.enabled']
export const isPipelinesClassicUIBannerEnabled =
  internalProps['teamcity.pipelines.classicUIBanner.enabled']
export const isStopAutocompleteForPrivateDockerIntegrations =
  internalProps['teamcity.ui.stopAutocompleteForPrivateDockerIntegrations.enabled']
export const isPullRequestsFeatureEnabled =
  internalProps['teamcity.pipelines.feature.pullRequests.enabled']
export const isTryPipelinesLinkEnabled =
  internalProps['teamcity.pipelines.tryPipelinesLink.enabled']
export const isTestDriveJobEnabled = internalProps['teamcity.pipelines.feature.testDriveJob']
export const isPipelinesIntegrationsNewUIEnabled =
  internalProps['teamcity.pipelines.integrations.newui.enabled']
export const isPipelineParameterInheritanceEnabled =
  internalProps['teamcity.pipelines.parameterInheritance.enabled']
export const isSidebarServerCacheEnabled =
  internalProps['teamcity.sidebar.projects.activeProjectsCache.enabled']
export const isPipelineRunActionsEnabled = internalProps['teamcity.pipelines.runActions.enabled']
export const isBuildPageHeaderActionsEnabled =
  internalProps['teamcity.ui.buildPage.headerActions.enabled']
export const isPipelinesBuildChainsEnabled = internalProps['teamcity.pipelines.buildChains.enabled']
export const pipelinesProhibitedVcsTypes =
  internalProps['teamcity.pipelines.creation.prohibitedVcsTypes']
